export const GET_ALLOYBORES_STATED = 'GET_ALLOYBORES_STATED';
export const GET_ALLOYBORES = 'GET_ALLOYBORES';
export const GET_ALLOYBORES_ENDED = 'GET_ALLOYBORES_ENDED';

export const ADD_ALLOYBORE_STATED = 'ADD_ALLOYBORE_STATED';
export const ADD_ALLOYBORE = 'ADD_ALLOYBORE';
export const ADD_ALLOYBORE_ENDED = 'ADD_ALLOYBORE_ENDED';

export const EDIT_ALLOYBORE_STATED = 'EDIT_ALLOYBORE_STATED';
export const EDIT_ALLOYBORE = 'EDIT_ALLOYBORE';
export const EDIT_ALLOYBORE_ENDED = 'EDIT_ALLOYBORE_ENDED';

export const GET_ALLOYBORE_STATED = 'GET_ALLOYBORE_STATED';
export const GET_ALLOYBORE = 'GET_ALLOYBORE';
export const GET_ALLOYBORE_ENDED = 'GET_ALLOYBORE_ENDED';

export const GET_ALL_ALLOYBORES_STATED = 'GET_ALL_ALLOYBORES_STATED';
export const GET_ALL_ALLOYBORES = 'GET_ALL_ALLOYBORES';
export const GET_ALL_ALLOYBORES_ENDED = 'GET_ALL_ALLOYBORES_ENDED';








